module.exports = __webpack_public_path__ + "static/img/products_02.46936b1e.png";